import * as React from "react"

import '../styles/404.css';

import { _ } from '../utils/l10n';
import { Layout } from '../components/layout';
import { Seo } from '../components/seo';
import { Link } from "gatsby";

const NotFoundPage = () => (
  <Layout contentClassName="not-found-page-content">
    <Seo title="Page not found" />
    <h1 className="title-1">{_('Page not found')}</h1>
    <p>{_('Sorry, the page you are looking for doesn’t exist')}</p>
    <p><Link to="/">{_('Go to homepage')}</Link></p>
  </Layout>
)

export default NotFoundPage

export const Head = () => <body className="page-404" />
